import { wait } from './wait';

export const withTimeout = <T>(promise: Promise<T>, timeoutMs: number, fallback: T): Promise<T> =>
  Promise.race([promise, wait(timeoutMs).then(() => fallback)]);
